import React from 'react';

const WellnessLifestylePage = () => {
  return (
    <div className="container mx-auto py-12 px-4 bg-gray-100 font-sans">
      
      <h1 className="text-4xl font-bold text-center mb-12 uppercase text-[#4a6b2e]">Wellness & Lifestyle</h1>
      
      {/* Articles Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        
        {/* Article 1 */}
        <div className="bg-white rounded-lg shadow-md overflow-hidden">
          <img 
            src="https://0120.ws/wp-content/uploads/2024/07/daily-mindfulness-practice1.jpg" 
            alt="Mindfulness" 
            className="w-full h-56 object-cover" 
          />
          <div className="p-6">
            <p className="text-xs uppercase text-gray-500 mb-2 font-bold">Mindfulness / Aug 10, 2024</p>
            <h3 className="text-xl font-bold text-[#4a6b2e] mb-3">5 Ways to Practice Daily Mindfulness</h3>
            <p className="text-sm text-gray-700 mb-4 leading-relaxed">
              Incorporate these simple techniques into your daily routine to reduce stress and improve focus.
            </p>
            <a href="#" className="text-[#008000] uppercase text-sm font-bold hover:underline">Read Article</a>
          </div>
        </div>

        {/* Article 2 */}
        <div className="bg-white rounded-lg shadow-md overflow-hidden">
          <img 
            src="https://goldenbuddhayoga.com/wp-content/uploads/2025/06/yoga-hero.webp" 
            alt="Yoga" 
            className="w-full h-56 object-cover" 
          />
          <div className="p-6">
            <p className="text-xs uppercase text-gray-500 mb-2 font-bold">Fitness / July 25, 2024</p>
            <h3 className="text-xl font-bold text-[#4a6b2e] mb-3">Beginner's Guide to Yoga at Home</h3>
            <p className="text-sm text-gray-700 mb-4 leading-relaxed">
              Discover the benefits of a home yoga practice and learn basic poses to get started on your journey.
            </p>
            <a href="#" className="text-[#008000] uppercase text-sm font-bold hover:underline">Read Article</a>
          </div>
        </div>
        
        {/* Article 3 */}
        <div className="bg-white rounded-lg shadow-md overflow-hidden">
          <img 
            src="https://optilifejourney.com/wp-content/uploads/2024/09/Debunking-the-Myths-The-Truth-About-a-Balanced-Diet-4.jpg" 
            alt="Healthy eating" 
            className="w-full h-56 object-cover" 
          />
          <div className="p-6">
            <p className="text-xs uppercase text-gray-500 mb-2 font-bold">Nutrition / June 15, 2024</p>
            <h3 className="text-xl font-bold text-[#4a6b2e] mb-3">Simple Meal Prep for a Healthy Week</h3>
            <p className="text-sm text-gray-700 mb-4 leading-relaxed">
              Get tips and easy recipes to plan and prepare your meals, saving time and staying on track.
            </p>
            <a href="#" className="text-[#008000] uppercase text-sm font-bold hover:underline">Read Article</a>
          </div>
        </div>

        {/* Article 4 */}
        <div className="bg-white rounded-lg shadow-md overflow-hidden">
          <img 
            src="https://cdn.shopify.com/s/files/1/0310/5472/5260/files/1_b68fbb95-0399-41db-981d-ce02d5225fbc.jpg?v=1672729598" 
            alt="Sleeping" 
            className="w-full h-56 object-cover" 
          />
          <div className="p-6">
            <p className="text-xs uppercase text-gray-500 mb-2 font-bold">Sleep / May 30, 2024</p>
            <h3 className="text-xl font-bold text-[#4a6b2e] mb-3">Building a Better Sleep Routine</h3>
            <p className="text-sm text-gray-700 mb-4 leading-relaxed">
              Discover powerful habits that can help you fall asleep faster and improve the quality of your rest.
            </p>
            <a href="#" className="text-[#008000] uppercase text-sm font-bold hover:underline">Read Article</a>
          </div>
        </div>

        {/* Article 5 */}
        <div className="bg-white rounded-lg shadow-md overflow-hidden">
          <img 
            src="https://burtonsbest.com/wp-content/uploads/2024/12/combat-stress.webp" 
            alt="Reducing stress" 
            className="w-full h-56 object-cover" 
          />
          <div className="p-6">
            <p className="text-xs uppercase text-gray-500 mb-2 font-bold">Mental Health / May 15, 2024</p>
            <h3 className="text-xl font-bold text-[#4a6b2e] mb-3">Natural Ways to Combat Stress</h3>
            <p className="text-sm text-gray-700 mb-4 leading-relaxed">
              Explore holistic approaches, including herbal remedies and breathing exercises, to manage daily stress.
            </p>
            <a href="#" className="text-[#008000] uppercase text-sm font-bold hover:underline">Read Article</a>
          </div>
        </div>

        {/* Article 6 */}
        <div className="bg-white rounded-lg shadow-md overflow-hidden">
          <img 
            src="https://img.freepik.com/premium-photo/woman-reading-lush-greenhouse-surrounded-by-green-plants-creating-tranquil-environment-aig_31965-488018.jpg" 
            alt="Clean home" 
            className="w-full h-56 object-cover" 
          />
          <div className="p-6">
            <p className="text-xs uppercase text-gray-500 mb-2 font-bold">Lifestyle / April 28, 2024</p>
            <h3 className="text-xl font-bold text-[#4a6b2e] mb-3">Creating a Tranquil Home Environment</h3>
            <p className="text-sm text-gray-700 mb-4 leading-relaxed">
              Learn how to declutter and organize your space to create a peaceful and relaxing sanctuary.
            </p>
            <a href="#" className="text-[#008000] uppercase text-sm font-bold hover:underline">Read Article</a>
          </div>
        </div>
        
      </div>
    </div>
  );
};

export default WellnessLifestylePage;